import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/firefightingClockIn',
    meta: { title: '消防打卡' },
    component: Layout,
    redirect: '/firefightingClockIn/list',
    children: [
      {
        path: 'list',
        meta: { title: '消防打卡', activeMenu: '/firefightingClockIn' },
        component: () => import('@/views/firefightingClockIn/FirefightingClockIn.vue')
      },
      {
        path: 'detail',
        meta: { title: '消防打卡详情', activeMenu: '/firefightingClockIn' },
        component: () => import('@/views/firefightingClockIn/FirefightingClockInDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增消防打卡', activeMenu: '/firefightingClockIn' },
        component: () => import('@/views/firefightingClockIn/FirefightingClockInAdd.vue')
      }

    ]
  }

]
